import { render } from "./successPayment1.vue?vue&type=template&id=3426e5e0&scoped=true"
import script from "./successPayment1.vue?vue&type=script&lang=js"
export * from "./successPayment1.vue?vue&type=script&lang=js"

import "./successPayment1.vue?vue&type=style&index=0&id=3426e5e0&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3426e5e0"]])

export default __exports__